<template>
    <div>
        <v-card flat>
            <v-toolbar color="#303a55" dark extended flat>
            </v-toolbar>
            <v-card class="mx-auto pa-4" max-width="700" style="margin-top: -64px;">
                <v-img :src="require('./../../assets/VULlogo.png')" width="100" height="100" class="mx-auto">
                </v-img>
                <v-card-title class="justify-center">Tell us your problem so we can get you the right help and support</v-card-title>
                <v-card-text class="mt-4">
                    <v-container>
                        <v-form v-model="valid" ref="form">
                            <v-text-field label="First Name" outlined color="#303a55" dense v-model="firstName" :rules="firstNameRules">
                            </v-text-field>
                            <v-text-field label="Last Name" outlined color="#303a55" dense v-model="lastName" :rules="lastNameRules">
                            </v-text-field>
                            <v-text-field label="Title" outlined color="#303a55" dense v-model="title" :rules="titleRules">
                            </v-text-field>
                            <v-textarea label="Tell us more" placeholder="Give us as much detail as you can, but do not include any private or sensitive information" outlined color="#303a55" dense v-model="description" :rules="descriptionRules">
                            </v-textarea>
                            <v-text-field label="Email" outlined color="#303a55" dense v-model="emailid" :rules="emailRules">
                            </v-text-field>
                            <v-text-field label="Phone" outlined color="#303a55" dense v-model="phoneNumber" :rules="phoneRules">
                            </v-text-field>
                            <v-combobox label="Department" v-model="department" :items="['General', 'DHA Admissions', 'Financial Aid', 'Registrar Office']" variant="outlined">
                            </v-combobox>
                            <v-btn color="#303a55" dark @click="submit" block class="mt-5" :loading="loading">
                                Submit
                            </v-btn>
                        </v-form>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-card>
        <snackbar :snackbar.sync="modal" :message.sync="message" :snackbarcolor.sync="color" v-on:closeSnackbar="closeSnackbar"></snackbar>
    </div>
</template>
<script>
    import Snackbar from './../Snackbar.vue';
    import {ZohoService} from './../../services/ZohoService.js';
    export default {
        data(){
            return{
                firstName: '',
                lastName: '',
                title: '',
                description: '',
                emailid: '',
                phoneNumber: '',
                department: '',
                firstNameRules: [
                    v => !!v || '*Required'
                ],
                lastNameRules: [
                    v => !!v || '*Required'
                ],
                titleRules: [
                    v => !!v || '*Required'
                ],
                descriptionRules: [
                    v => !!v || '*Required'
                ],
                emailRules: [
                    v => !!v || '*Required',
                    v => /.+@.+\..+/.test(v) || 'E-mail must be valid'
                ],
                phoneRules: [
                    v => !!v || '*Required'
                ],
                valid: false,
                modal: false,
                message: '',
                loading: false,
                color: 'red accent-3'
            }
        },
        components: {
            Snackbar
        },
        methods: {
            closeSnackbar(value){
                this.modal=value;
            },
            submit(){
                let data = {
                    firstName: this.firstName,
                    lastName: this.lastName,
                    department: this.department,
                    title: this.title,
                    description: this.description,
                    emailid: this.emailid,
                    phoneNumber: this.phoneNumber,
                };
                if(this.$refs.form.validate()){
                    this.loading = true;
                    ZohoService.submit(data).then((response) => {
                        this.modal = true;
                        this.color = "success";
                        this.message = "Thank you! Your ticket is successfully raised.";
                        this.$refs.form.reset();
                        this.loading = false;
                        console.log('response', response.data.message);
                    }).catch((error) => {
                        this.modal = true;
                        this.color = "red accent-3";
                        console.log(JSON.stringify(error))
                        this.message = error;
                        this.loading = false;
                    })
                }
                else{
                    this.modal = true;
                    this.color = "red accent-3";
                    this.message = "Please fill in the details to continue";   
                }
            }
        },
    }
</script>